if (!customElements.get('sale-box-usa-form')) {
  customElements.define('sale-box-usa-form', class SaleBoxUSAForm extends HTMLElement {
    constructor() {
      super();
      this.blockId = this.dataset.blockId;
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.qtyHidden = this.querySelector('[data-sale-box-usa-quantity-hidden]');
      this.variantTitleHidden = this.querySelector('[data-sale-box-usa-variant-title]');
      this.variantIdHidden = this.querySelector('[data-sale-box-usa-variant-id]');
      this.skuHidden = this.querySelector('[data-sale-box-usa-sku]');
      this.form.addEventListener('submit', this.syncContext.bind(this));
    }

    syncContext() {
      const qtyInput = document.querySelector('[data-sale-box-usa-quantity]');
      if (qtyInput && qtyInput.value && this.qtyHidden) {
        this.qtyHidden.value = qtyInput.value;
      }
      const variantIdField = document.querySelector('.product-variant-id');
      if (variantIdField && variantIdField.value && this.variantIdHidden) {
        this.variantIdHidden.value = variantIdField.value;
      }
      const variantSelect = document.querySelector('variant-selects [name^="options"], variant-radios input[name^="options"]:checked');
      if (variantSelect && this.variantTitleHidden) {
        const selectedOptions = Array.from(document.querySelectorAll('variant-radios input[type="radio"]:checked, variant-selects select')).map((el) => el.value).filter(Boolean);
        if (selectedOptions.length) this.variantTitleHidden.value = selectedOptions.join(' / ');
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const successMsg = document.querySelector('[data-sale-box-usa-success]');
  if (!successMsg) return;
  const modal = successMsg.closest('modal-dialog');
  if (!modal) return;
  if (typeof modal.show === 'function') modal.show();

  const resetToCleanUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('contact_posted');
    url.searchParams.delete('form_type');
    url.hash = '';
    window.location.replace(url.pathname + url.search);
  };
  const observer = new MutationObserver(() => {
    if (!modal.hasAttribute('open') && !modal.classList.contains('closing')) {
      observer.disconnect();
      resetToCleanUrl();
    }
  });
  observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
});
